import {
  EVENT_LIST,
  EVENT_LOADER,
  EVENT_VIDEO_LIST,
  GET_SUBSCRIPTION_LIST,
  GET_USER_SLOTS,
  MODIFY_SUBSCRIPTION_STATUS,
  SAVE_USER_SLOT,
  USER_SUBSCRIPTION_STATUS,
  CATEGORY_V2_LIST,
  CALENDAR_SERVICE_LIST,
  SPECIALIZATION_V2_LIST,
  GET_USER_SERVICE,
  GET_USER_SERVICE_RESOURCE,
  GET_SERVICE_DASHBOARD,
  SAVE_PAGES,
  DELETE_PAGE,
  GET_SERVICE_DASHBOARD_PASSBOOK,
  FETCH_EXPERT_BOOKINGS_REQUEST,
  FETCH_EXPERT_BOOKINGS_SUCCESS,
  FETCH_EXPERT_BOOKINGS_FAILURE,
  FETCH_EXPERT_BOOKINGS_COUNT,
} from "../types";

const initialState = {
  eventList: [],
  eventLoader: false,
  eventSeeMore: false,
  totalPage: 0,
  userSlots: null,
  subscriptionList: [],
  subscriptionStatus: false,
  subscriptionDetails: null,
  subscriptionType: null,
  subscriptionModel: false,
  categoryList: [],
  calendarServices: [],
  expiryDate: new Date(),
  userServiceList: [],
  prefComplete: false,
  calendarComplete: false,
  serviceComplete: false,
  subCategoryV2: [],
  categoryV2: [],
  serviceDashboard: null,
  passbook: null,
  resourceList: [],
};

export default function calendarReducer(state = initialState, action) {
  switch (action.type) {
    case GET_SERVICE_DASHBOARD:
      console.log("GET_SERVICE_DASHBOARD", action.payload);
      return {
        ...state,
        serviceDashboard: action.payload,
      };
    case EVENT_LOADER:
      return {
        ...state,
        eventLoader: action.payload,
      };
    case EVENT_LIST:
      console.log("EVENT_LIST", action.payload);
      let list =
        action.page === 0
          ? action.payload.content
          : state.eventList.concat(action.payload.content);
      return {
        ...state,
        eventLoader: false,
        eventList: list ? list : [],
        eventSeeMore: action.payload?.totalPages - 1 > action.page,
      };
    case EVENT_VIDEO_LIST:
      console.log("EVENT_VIDEO_LIST", action.payload);
      let eventVideoList =
        action.page === 0
          ? action.payload.content
          : state.eventVideoList.concat(action.payload.content);
      return {
        ...state,
        eventLoader: false,
        eventVideoList: eventVideoList ? eventVideoList : [],
        eventSeeMore: action.payload?.totalPages - 1 > action.page,
      };
    case GET_USER_SLOTS:
      console.log("GET_USER_SLOTS", action.payload);
      return {
        ...state,
        userSlots: action.payload,
        eventLoader: false,
        prefComplete: action.payload.preference !== null,
        calendarComplete: action.payload?.slots?.length !== 0,
      };

    case SAVE_PAGES:
      console.log("SAVE_PAGES", action.payload);
      const prevList = state.userSlots?.preference?.subPages?.length
        ? state.userSlots?.preference?.subPages
        : null;

      if (prevList) {
        const isUpdate = prevList.some((item) => item.id === action.payload.id);

        if (isUpdate)
          state.userSlots.preference.subPages = prevList.map((item) => {
            if (item.id === action.payload.id) {
              return action.payload;
            }
            return item;
          });
        else
          state.userSlots.preference.subPages = [...prevList, action.payload];
      } else {
        state.userSlots.preference.subPages = [action.payload];
      }
      console.log("SAVE_PAGES STATE", state);

      return { ...state };

    case DELETE_PAGE:
      console.log("DELETE_PAGE", action.payload);
      console.log("DELETE_PAGE opr", state.userSlots.preference.subPages);

      state.userSlots.preference.subPages = [
        ...state.userSlots.preference.subPages,
      ].filter((item) => item.id !== action.payload.id);

      return { ...state };
    case GET_SUBSCRIPTION_LIST:
      console.log("GET_SUBSCRIPTION_LIST", action.payload);
      return {
        ...state,
        subscriptionList: action.payload ? action.payload : [],
      };
    case USER_SUBSCRIPTION_STATUS:
      
      const newDay = new Date(new Date());
      newDay.setDate(new Date().getDate() + action.payload?.daysRemaining ?? 1);
      return {
        ...state,
        subscriptionStatus: action.payload.subscription,
        subscriptionDetails: action.payload,
        subscriptionType: action.subscriptionType,
        expiryDate: newDay,
      };
    case MODIFY_SUBSCRIPTION_STATUS:
      console.log("MODIFY_SUBSCRIPTION_STATUS", action.payload);
      return {
        ...state,
        subscriptionModel: action.payload,
      };
    case CATEGORY_V2_LIST:
      console.log("CATEGORY_V2_LIST", action.payload);
      return {
        ...state,
        categoryList: action.payload,
      };
    case CALENDAR_SERVICE_LIST:
      console.log("CALENDAR_SERVICE_LIST", action.payload);
      return {
        ...state,
        calendarServices: action.payload,
      };
    case SPECIALIZATION_V2_LIST:
      console.log("SPECIALIZATION_V2_LIST", action.payload);
      return {
        ...state,
        categoryV2: action.payload.category ?? [],
        subCategoryV2: action.payload.subCategory ?? [],
      };
    case GET_USER_SERVICE:
      console.log("GET_USER_SERVICE", action.payload);
      return {
        ...state,
        userServiceList: action.payload,
        serviceComplete: action.payload?.length !== 0,
      };

         case GET_USER_SERVICE_RESOURCE:
      console.log("GET_USER_SERVICE_RESOURCE", action.payload);
      return {
        ...state,
        resourceList: action.payload,
      };
         case GET_SERVICE_DASHBOARD_PASSBOOK:
      console.log("GET_USER_SERVICE", action.payload);
      return {
        ...state,
           passbook: action.payload.settlementTransactions, // ✅ ARRAY
    passbookTotalCount: action.payload.totalCount,   // optional
      };

      case FETCH_EXPERT_BOOKINGS_REQUEST:
  return {
    ...state,
    expertBookings: {
      ...state.expertBookings,
      loading: true,
      error: null,
    },
  };

case FETCH_EXPERT_BOOKINGS_SUCCESS:
  return {
    ...state,
    expertBookings: {
      loading: false,
      count: action.payload.count,
      data: action.payload.data,
      error: null,
    },
  };

case FETCH_EXPERT_BOOKINGS_FAILURE:
  return {
    ...state,
    expertBookings: {
      loading: false,
      count: 0,
      data: [],
      error: true,
    },
  };

  case FETCH_EXPERT_BOOKINGS_COUNT:
  return {
    ...state,
    loading: false,
    expertBookingsCount: action.payload,
  };

    default:
      return state;
  }
}
